import { jsx as t } from "react/jsx-runtime";
import { d as B, al as g, j as v } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as _ } from "react";
import { stupidInvertClasses as $ } from "../../utils/index.js";
import { getButtonStyles as x } from "../BaseButton/index.js";
import { BaseIcon as a } from "../BaseIcon/index.js";
import { isIconName as d } from "../BaseIcon/typeGuards.js";
import { DotProgress as y } from "../DotProgress/index.js";
import { withTooltip as I } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as l } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index40.css';const b = "_iconButton_1nqu5_1", h = "_currentcolor_1nqu5_6", u = {
  iconButton: b,
  currentcolor: h
}, L = I(
  _(
    ({
      isPendingAriaLabel: f = "Loading...",
      size: e = "md",
      icon: r,
      iconColor: n,
      href: c,
      __inverted: p,
      variant: s = "secondary",
      ...o
    }, i) => {
      const m = B(
        x({
          size: e,
          variant: s,
          ...o
        }),
        n === "currentcolor" ? u.currentcolor : void 0,
        u.iconButton,
        p ? $() : void 0
      );
      return typeof c == "string" ? /* @__PURE__ */ t(
        g,
        {
          ...l(o),
          href: c,
          className: m,
          slot: null,
          ref: i,
          children: d(r) && /* @__PURE__ */ t(a, { icon: r, size: "md" })
        }
      ) : /* @__PURE__ */ t(
        v,
        {
          ...l(o),
          type: "button",
          "data-active": o.isActive ? "true" : void 0,
          className: m,
          ref: i,
          "data-component": "IconButton",
          children: o.isPending ? /* @__PURE__ */ t(y, { "aria-label": f, size: e }) : d(r) && /* @__PURE__ */ t(a, { icon: r, size: "md", color: s === "ghost" ? n : void 0 })
        }
      );
    }
  )
);
export {
  L as IconButton
};
